// ProgressBar.js

import React from 'react';

const ProgressBar = ({ progress, processing = false, processingText = '', processingDots = 0 }) => {
    if (processing) {
        // Text-based progress indicator for server-side processing
        return (
            <div style={{ width: '100%', backgroundColor: 'blue', color: 'white', textAlign: 'center', padding: '10px' }}>
                {processingText + '.'.repeat(processingDots)}
            </div>
        );
    } else {
        // Percentage-based progress bar for file upload
        const progressBarStyle = {
            width: `${progress}%`,
            height: '20px',
            backgroundColor: 'blue',
            textAlign: 'center',
            lineHeight: '20px',
            color: 'white'
        };
        return (
            <div style={{ width: '100%', backgroundColor: '#ddd' }}>
                <div style={progressBarStyle}>{progress}%</div>
            </div>
        );
    }
};

export default ProgressBar;
